import { jsx as _jsx } from "react/jsx-runtime";
import { Close as CloseIcon } from "@mui/icons-material";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers-pro";
import { IconButton, TextField } from "@mui/material";
import moment from "moment";
import React from "react";
import { useLocale } from "../LocaleProvider.js";
export const DateTimePickerMui = ({ disabled, label, value, minValue, maxValue, onChange, disablePast = false, disableFuture = false, ...otherProps }) => {
    const locale = useLocale();
    const format = `${moment.localeData(locale).longDateFormat("L")} ${moment
        .localeData(locale)
        .longDateFormat("LT")}`;
    return (_jsx(MuiDateTimePicker, { ampm: false, value: value, onChange: (date) => {
            onChange(null, date);
        }, disableFuture: disableFuture, disablePast: disablePast, label: label, disabled: disabled, minDate: minValue, maxDate: maxValue, views: ["year", "month", "day", "hours", "minutes"] }));
};
export const DateTimePickerNative = ({ disabled, label, value, minValue, maxValue, onChange, isClearable = false, disablePast = false, disableFuture = false, inputProps, InputProps, InputLabelProps, ...otherProps }) => {
    const min = React.useMemo(() => {
        if (minValue)
            return convertToNativeDateTimePickerFormat(minValue);
        if (disablePast)
            return convertToNativeDateTimePickerFormat(moment());
        return undefined;
    }, [minValue, disablePast]);
    const max = React.useMemo(() => {
        if (maxValue)
            return convertToNativeDateTimePickerFormat(maxValue);
        if (disableFuture)
            return convertToNativeDateTimePickerFormat(moment());
        return undefined;
    }, [maxValue, disableFuture]);
    return (_jsx(TextField, { type: "datetime-local", label: label, disabled: disabled, value: convertToNativeDateTimePickerFormat(value), onChange: (e) => {
            const date = e.target.value ? moment(e.target.value) : null;
            onChange(e, date && date.isValid() ? date : null);
        }, ...otherProps, slotProps: {
            input: {
                endAdornment: isClearable ? (value ? (_jsx(IconButton, { size: "small", color: "primary", onClick: () => {
                        onChange(null, null);
                    }, "aria-label": "Clear", style: { position: "relative", top: 8 }, children: _jsx(CloseIcon, { fontSize: "small" }) })) : undefined) : undefined,
                ...InputProps,
            },
            htmlInput: {
                min,
                max,
                ...inputProps,
            },
            inputLabel: {
                shrink: true,
                ...InputLabelProps,
            },
        } }));
};
const convertToNativeDateTimePickerFormat = (date) => {
    return date ? date?.format(moment.HTML5_FMT.DATETIME_LOCAL) : "";
};
export const DateTimePicker = ({ browserHasInputDateTime, ...props }) => {
    return browserHasInputDateTime ? (_jsx(DateTimePickerNative, { ...props })) : (_jsx(DateTimePickerMui, { ...props }));
};
//# sourceMappingURL=DateTimePicker.js.map